import { render, staticRenderFns } from "./ServiceObjectMaintenanceNotesTable.vue?vue&type=template&id=4a575fbc&"
import script from "./ServiceObjectMaintenanceNotesTable.vue?vue&type=script&lang=js&"
export * from "./ServiceObjectMaintenanceNotesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QField,QBtn,QTooltip,QCheckbox,QTable,QTh,QTr,QTd,QCardSection,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QField,QBtn,QTooltip,QCheckbox,QTable,QTh,QTr,QTd,QCardSection,QInnerLoading,QSpinnerGears}, component.options.components || {})
